import { render } from "./SurveysIcon.vue?vue&type=template&id=8722c206"
import script from "./SurveysIcon.vue?vue&type=script&lang=js"
export * from "./SurveysIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__